'use strict';
var parent = require('../../actual/json/stringify');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/json/stringify.js
// module id = 629
// module chunks = 13